import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Link } from 'react-router-dom';
import { Mail, CheckCircle, ArrowLeft } from '../../icons';

const required   = (val) => val && val.length;
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

function DemandResetPassword(props) {
    const [isSentEmail, setIsSentEmail] = useState(false);

    function handleDemandResetPassword(values) {
        props.sendEmailResetPassword(values.email);
        setIsSentEmail(true);
    }

    if (isSentEmail) {
        return (
            <div className="auth-page">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-5 col-lg-4">
                            <div className="auth-card text-center">
                                <div style={{ width: 64, height: 64, borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                                    <CheckCircle size={32} strokeWidth={1.8} color="#2e7d32" />
                                </div>
                                <h2 className="auth-title">E-mail envoyé !</h2>
                                <p className="auth-subtitle">
                                    Consultez votre boîte mail et cliquez sur le lien de réinitialisation. Si vous ne le trouvez pas, vérifiez votre dossier spam.
                                </p>
                                <Link to="/login" className="auth-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8 }}>
                                    <ArrowLeft size={15} strokeWidth={2.5} /> Retour à la connexion
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="auth-page">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-5 col-lg-4">
                        <div className="auth-card">
                            <div style={{ width: 52, height: 52, borderRadius: 14, background: 'var(--primary-light)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                                <Mail size={26} strokeWidth={1.8} color="var(--primary)" />
                            </div>
                            <h1 className="auth-title">Mot de passe oublié ?</h1>
                            <p className="auth-subtitle">
                                Saisissez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.
                            </p>
                            <LocalForm
                                onSubmit={(values) => handleDemandResetPassword(values)}
                                validators={{ email: { required, validEmail } }}
                            >
                                <div className="form-group mb-4">
                                    <Control.text model=".email" id="email" name="email"
                                        placeholder="Adresse e-mail"
                                        className="form-control auth-input"
                                        validators={{ required, validEmail }}
                                    />
                                    <Errors className="errors" model=".email" show="touched"
                                        messages={{ required: 'Champ requis.', validEmail: "Format d'e-mail invalide." }} />
                                </div>
                                <Button type="submit" color="primary" className="auth-submit mb-3">
                                    Envoyer le lien de réinitialisation
                                </Button>
                            </LocalForm>
                            <div className="auth-footer">
                                <Link to="/login" className="auth-link" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                    <ArrowLeft size={14} strokeWidth={2.5} /> Retour à la connexion
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DemandResetPassword;
